import { ok } from 'node:assert';
import { createProxy } from 'http-proxy-3';

import type { PluginOption, ViteDevServer } from 'vite';
import type { IncomingMessage } from 'node:http';
import type { ProxyServer } from 'http-proxy-3';

function getLocalDevServerUrl(server: ViteDevServer): string {
  const [localUrl] = server.resolvedUrls?.local ?? [];
  ok(localUrl != null);

  const parsedUrl = new URL(localUrl);
  parsedUrl.pathname = '/';

  return parsedUrl.toString();
}

export const createProxyDevServersPlugin = () => {
  const proxyMap = new Map<string, { url: string; proxy: ProxyServer }>();

  const registerProxyDevServer = (devServer: ViteDevServer) => {
    const base = devServer.config.base;
    const url = getLocalDevServerUrl(devServer);
    const proxy = createProxy();

    proxyMap.set(base, { url, proxy });
  };

  const applyProxyDevServers = (): PluginOption => {
    return {
      name: 'wix:proxy-dev-servers',
      apply: 'serve',
      configureServer(server) {
        server.middlewares.use((req, res, next) => {
          for (const [base, { url, proxy }] of proxyMap.entries()) {
            if (req.url?.startsWith(base)) {
              proxy.web(req, res, {
                changeOrigin: true,
                target: url,
              });

              return;
            }
          }
          next();
        });

        server.httpServer?.on(
          'upgrade',
          (req: IncomingMessage, socket: unknown, head: unknown) => {
            for (const [base, { url, proxy }] of proxyMap.entries()) {
              if (req.url?.startsWith(base)) {
                proxy.ws(req, socket, head, {
                  changeOrigin: true,
                  target: url,
                });

                return;
              }
            }

            return;
          }
        );
      },
    };
  };

  return { applyProxyDevServers, registerProxyDevServer };
};
